// @ts-nocheck
import { transitionStyles } from "@toolkit/Themes/common/mixins";
// Foundation --->
import { css } from "styled-components";
// <--- Foundation

export const transitionHoverStyles = (...properties: string[]) => {
    return transitionStyles("short", "ease-out", properties);
};

export const transitionControlStyles = (...properties: string[]) => {
    return transitionStyles("regular", "ease-out", properties);
};

export const transitionAnimationStyles = (...properties: string[]) => {
    return transitionStyles("long", "ease-in-out", properties);
};

// Foundation --->
export const categoriesTilesTransition = (options: { property: string; hasDelay?: boolean }) => css`
    transition: ${options.property} 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) ${options.hasDelay ? "0.05s" : null};
`;
// <--- Foundation
